import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Organization } from '../../shared-api/organization/organization.model';

@Injectable({
    providedIn: 'root'
})
export class BroadcastService
{
    // Subjects
    showHeader = new Subject<boolean>();                                                    // Sent to show/hide header component.
    viewModeChanged = new Subject();
    // showLoadingOverlay = new Subject<boolean>();

    windowResize = new Subject<any>();                                                      // Sent whenever the app Viewport is resized.
    organizationChanged = new Subject<Organization>();                                      // Sent when Global Admin selects an Organization from header drop-down.
    organizationListChanged = new Subject();                                                // Sent when organization list is updated
    userSignedOut = new Subject<string>();                                                  // Called when user signs out. Allows subscribers to take appropriate action (e.g., clear caches)

    constructor()
    {
    }
}
